import { render, staticRenderFns } from "./DonateIcon.vue?vue&type=template&id=1e5cd8ee"
import script from "./DonateIcon.vue?vue&type=script&lang=js"
export * from "./DonateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports